import { ValueOf } from './util';

/** プリペイド区分 */
export const EPrepaidType = {
  NORMAL: '通常（プリペイド）',
  GIFT_CERTIFICATE: '商品券',
} as const;

export type PrepaidTypeKey = keyof typeof EPrepaidType;
export type PrepaidTypeValue = ValueOf<typeof EPrepaidType>;

export const prepaidTypeKeys = Object.keys(EPrepaidType) as (PrepaidTypeKey[]);

/** v-select用items */
export const prepaidTypeItems = prepaidTypeKeys
  .map((key) => ({
    title: EPrepaidType[key],
    value: key,
  }));
